import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../authentication/authentication.service';
import { LoggingService } from '../logging/logging.service';
import { Coupon, CreateCouponModel, EditCouponModel, RedeemResponse } from '../../models/inModels/Coupon';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { LazyLoadEvent } from 'primeng/primeng';

@Injectable()
export class CouponService {
  private route = '/api/coupons/';
  constructor(
    private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService
  ) { }

  create(model: CreateCouponModel): Observable<Coupon> {
		return this.http.post(`${this.auth.apiUrl}${this.route}create`, JSON.stringify(model), { headers: this.auth.header })
			.pipe(map(response => response as Coupon))
			.pipe(catchError(error => this.logging.handleError(error)));
	}
  
  search(event: LazyLoadEvent): Observable<any> {
		return this.http.post(`${this.auth.apiUrl}${this.route}search`, JSON.stringify(event), { headers: this.auth.header })
			.pipe(map(response => response))
			.pipe(catchError(error => this.logging.handleError(error)));
	}

  get(code: string): Observable<Coupon> {
		return this.http.get(`${this.auth.apiUrl}${this.route}get/${code}`, { headers: this.auth.header })
			.pipe(map(response => response as Coupon))
			.pipe(catchError(error => this.logging.handleError(error)));
	}

  edit(model: EditCouponModel): Observable<Coupon> {
		return this.http.post(`${this.auth.apiUrl}${this.route}update`, JSON.stringify(model), { headers: this.auth.header })
			.pipe(map(response => response))
			.pipe(catchError(error => this.logging.handleError(error)));
	}
  
  delete(code: string): Observable<any> {
		return this.http.get(`${this.auth.apiUrl}${this.route}delete/${code}`, { headers: this.auth.header })
			.pipe(map(response => response as any))
			.pipe(catchError(error => this.logging.handleError(error)));
	}

  redeem(code: string, reference: string): Observable<RedeemResponse> {
		return this.http.post(`${this.auth.apiUrl}${this.route}redeem`, JSON.stringify({
			Code: code,
			PaymentReference: reference
		}), { headers: this.auth.header })
		.pipe(map(response => response))
		.pipe(catchError(error => this.logging.handleError(error)));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/coupon/coupon.service.ts